import script from "./BasketLineItemUpSell.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasketLineItemUpSell.vue?vue&type=script&lang=ts&setup=true"

import "./BasketLineItemUpSell.vue?vue&type=style&index=0&id=dac5988c&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dac5988c"]])

export default __exports__